import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const originalReplace = Router.prototype.replace
Router.prototype.replace = function (location) {
  return originalReplace.call(this, location).catch(err => err)
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        {
          path: '/',
          name: 'page-login',
          component: () => import('@/views/pages/Login.vue')
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        }
      ]
    },

    {
      path: '/',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        {
          path: '/home',
          name: 'home',
          component: () => import('./views/Home.vue')
        },
        {
          path: '/judicial',
          name: 'Judicial',
          component: () => import('./views/Judicial.vue')
        },
        {
          path: '/perfil',
          name: 'Perfil',
          component: () => import('./views/Perfil.vue')
        },
        {
          path: '/videocall',
          name: 'Videocall',
          component: () => import('./views/Videocall.vue')
        },
        {
          path: '/addContact',
          name: 'Add-Contact',
          component: () => import('./views/Add-Contact.vue')
        },
        {
          path: '/contactList',
          name: 'Contact-List',
          component: () => import('./views/Contact-List.vue')
        },
        {
          path: '/editContact/:id',
          name: 'Contact-edit',
          component: () => import('./views/user/user-edit/UserEdit.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'User' },
              { title: 'Edit', active: true }
            ],
            pageTitle: 'User Edit',
            rule: 'editor'
          }
        },
      ]
    },
    
    // Redirect to 404 page, if no match found
    /* {
      path: '*',
      redirect: '/pages/error-404'
    } */
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
